var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrinters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7188 13.8197C30.7188 13.7645 30.674 13.7197 30.6188 13.7197H19.8188C19.7635 13.7197 19.7188 13.7645 19.7188 13.8197V20.6197C19.7188 20.675 19.7635 20.7197 19.8188 20.7197H21.6187C21.674 20.7197 21.7188 20.7645 21.7188 20.8197V25.3329C21.7188 25.3663 21.7355 25.3975 21.7633 25.4161L25.1633 27.6827C25.1969 27.7051 25.2406 27.7051 25.2742 27.6827L28.6742 25.4161C28.702 25.3975 28.7188 25.3663 28.7188 25.3329V20.8197C28.7188 20.7645 28.7635 20.7197 28.8188 20.7197H30.6187C30.674 20.7197 30.7188 20.675 30.7188 20.6197V13.8197Z",
    stroke: "#333333",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2188 31.7197V32.7197C25.2188 34.3766 23.8756 35.7197 22.2188 35.7197H13.7188",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7188 15.7197L13.7187 15.7197",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7188 15.7197L30.7188 15.7197",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinters);
export default __webpack_public_path__ + "static/media/printers.1e5d657b3d4facb59ec719e5966decc4.svg";
export { ForwardRef as ReactComponent };